export const request = (input: RequestInfo | URL, init?: RequestInit) =>
  parent.fetch(input, init).then((res) => (res.ok ? Promise.resolve(res) : Promise.reject(res)))
